import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { theme } from '../components/theme';
import { useNavigate } from 'react-router-dom';

export const ProductCard = ({
  name,
  description,
  icon,
  features,
  link,
  handleClick
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: theme.colors.neutral.white,
        borderRadius: theme.borderRadius['2xl'],
        padding: theme.spacing.xl,
        border: `1px solid ${theme.colors.neutral.gray100}`,
        boxShadow: isHovered ? theme.shadows.xl : theme.shadows.lg,
        transform: isHovered ? 'translateY(-8px)' : 'translateY(0)',
        transition: `all ${theme.transitions.base}`,
        cursor: 'pointer',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          fontSize: '48px',
          marginBottom: theme.spacing.lg,
          textAlign: 'center',
          transition: `transform ${theme.transitions.base}`,
          transform: isHovered ? 'scale(1.1)' : 'scale(1)',
        }}
      >
        {icon}
      </div>

      <h3
        style={{
          fontSize: theme.typography.fontSize['2xl'],
          fontWeight: theme.typography.fontWeight.bold,
          color: theme.colors.primary.navy,
          marginBottom: theme.spacing.md,
          textAlign: 'center',
          lineHeight: theme.typography.lineHeight.tight,
        }}
      >
        {name}
      </h3>

      <p
        style={{
          fontSize: theme.typography.fontSize.base,
          color: theme.colors.primary.blue,
          marginBottom: theme.spacing.lg,
          textAlign: 'center',
          lineHeight: theme.typography.lineHeight.relaxed,
          flex: 1,
        }}
      >
        {description}
      </p>

      <div style={{ marginBottom: theme.spacing.xl }}>
        <h4
          style={{
            fontSize: theme.typography.fontSize.base,
            fontWeight: theme.typography.fontWeight.semibold,
            color: theme.colors.primary.navy,
            marginBottom: theme.spacing.md,
          }}
        >
          Key Features:
        </h4>
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
          }}
        >
          {features.map((feature, index) => (
            <li
              key={index}
              style={{
                fontSize: theme.typography.fontSize.sm,
                color: theme.colors.primary.blue,
                marginBottom: theme.spacing.sm,
                paddingLeft: theme.spacing.lg,
                position: 'relative',
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  left: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '6px',
                  height: '6px',
                  backgroundColor: theme.colors.primary.orange,
                  borderRadius: '50%',
                }}
              />
              {feature}
            </li>
          ))}
        </ul>
      </div>

      <button
        onClick={() => handleClick(link)}

        style={{
          width: '100%',
          padding: '14px 24px',
          fontSize: theme.typography.fontSize.base,
          fontWeight: theme.typography.fontWeight.semibold,
          color: theme.colors.neutral.white,
          backgroundColor: theme.colors.primary.orange,
          border: 'none',
          borderRadius: theme.borderRadius.md,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: theme.spacing.sm,
          transition: `all ${theme.transitions.fast}`,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = theme.colors.primary.orangeLight;
          const arrow = e.currentTarget.querySelector('.arrow-icon');
          if (arrow) arrow.style.transform = 'translateX(4px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = theme.colors.primary.orange;
          const arrow = e.currentTarget.querySelector('.arrow-icon');
          if (arrow) arrow.style.transform = 'translateX(0)';
        }}
      >
        Learn More
        <ArrowRight
          className="arrow-icon"
          size={18}
          style={{ transition: `transform ${theme.transitions.fast}` }}
        />
      </button>
    </div>
  );
};
